module.exports = __webpack_public_path__ + "img/playerBlueBtn.eaa4b250.svg";